import React, { useEffect, useState } from 'react';

import CloseIcon from '@material-ui/icons/Close';
import GetAppIcon from '@material-ui/icons/GetApp';
import {
    InstallBanner,
    BannerContent,
    BannerTitle,
    BannerDescription,
    ButtonGroup,
    StyledButton,
    InstallButton,
    CloseButton,
} from './InstallPWA.styles';

const InstallPWA = () => {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        // Check if already installed
        const isInstalled = globalThis.matchMedia('(display-mode: standalone)').matches
                          || globalThis.navigator.standalone === true;

        if (isInstalled) {
            return;
        }

        // Check if user previously dismissed
        const dismissed = localStorage.getItem('pwa-install-dismissed');
        const dismissedTime = localStorage.getItem('pwa-install-dismissed-time');

        if (dismissed === 'true' && dismissedTime) {
            // Show again after 7 days
            const sevenDays = 7 * 24 * 60 * 60 * 1000;
            const now = Date.now();
            if (now - Number.parseInt(dismissedTime) < sevenDays) {
                return;
            }
        }

        // Listen for the beforeinstallprompt event
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);

            // Show banner after 3 seconds
            setTimeout(() => {
                setShowBanner(true);
            }, 1000);
        };

        globalThis.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

        // Listen for successful installation
        globalThis.addEventListener('appinstalled', () => {
            console.log('PWA was installed');
            setShowBanner(false);
            setDeferredPrompt(null);
            localStorage.removeItem('pwa-install-dismissed');
            localStorage.removeItem('pwa-install-dismissed-time');
        });

        return () => {
            globalThis.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);

    const handleInstallClick = async () => {
        if (!deferredPrompt) {
            return;
        }

        // Show the install prompt
        deferredPrompt.prompt();

        // Wait for the user to respond to the prompt
        const { outcome } = await deferredPrompt.userChoice;

        if (outcome === 'accepted') {
            console.log('User accepted the install prompt');
        } else {
            console.log('User dismissed the install prompt');
        }

        // Clear the deferred prompt
        setDeferredPrompt(null);
        setShowBanner(false);
    };

    const handleDismiss = () => {
        setShowBanner(false);
        localStorage.setItem('pwa-install-dismissed', 'true');
        localStorage.setItem('pwa-install-dismissed-time', Date.now().toString());
    };

    const handleLater = () => {
        setShowBanner(false);
    };

    if (!deferredPrompt || !showBanner) {
        return null;
    }

    return (
        <InstallBanner show={showBanner}>
            <BannerContent>
                <BannerTitle>Install BestWork</BannerTitle>
                <BannerDescription>
                    Install the app for quick access
                </BannerDescription>
            </BannerContent>
            <ButtonGroup>
                <StyledButton
                    variant="outlined"
                    size="small"
                    onClick={handleLater}
                >
                    Later
                </StyledButton>
                <InstallButton
                    variant="contained"
                    size="small"
                    startIcon={<GetAppIcon />}
                    onClick={handleInstallClick}
                >
                    Install
                </InstallButton>
            </ButtonGroup>
            <CloseButton onClick={handleDismiss}>
                <CloseIcon fontSize="small" />
            </CloseButton>
        </InstallBanner>
    );
};

export default InstallPWA;
